import React from "react";
import { Grid } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { StyledBanner } from "../../../common/components/BannerTitle/styles";
import BannerInfo from "../../../common/components/BannerInfo";
import {
  StyledText,
  StyledLink,
} from "../../../common/components/Title/styles";
const ServiceProvidersDashboardBanner = ({ serviceData, theme }) => {
  const navigate = useNavigate();

  return (
    <StyledBanner theme={theme}>
      <StyledLink
        style={{ paddingTop: "20px", paddingLeft: "20px", cursor: "pointer" }}
        theme="purple"
        onClick={() => navigate("/settings")}
      >
        <FontAwesomeIcon
          style={{ fontSize: "19px", paddingRight: "5px" }}
          icon={faAngleLeft}
          FontAwesomeIcon
        />
        Back to Settings
      </StyledLink>

      <div style={{ display: "flex", flexDirection: "row", padding: "15px" }}>
        <div style={{ display: "flex", flexDirection: "row", width: "650px" }}>
          <BannerInfo
            stlye={{
              display: "flex",
              flexDirection: "column",
              paddingRight: "20px",
            }}
          >
            <Grid container spacing={1} style={{ marginBottom: "6px" }}>
              <Grid item xs={8}>
                <StyledText
                  display="block"
                  width="full"
                  fontSize={14}
                  fontWeight={700}
                  borderRadius="100px"
                  theme="lightpurple"
                >
                  <div style={{ color: "black" }}>Service Information</div>
                </StyledText>
              </Grid>
              <Grid item xs={12}>
                <hr sx={{ height: "1px", border: 0 }} />
              </Grid>
              <Grid item xs={8}>
                <StyledText fontSize={25} fontWeight={600} theme="purple">
                  <div>{serviceData.name}</div>
                </StyledText>
              </Grid>
            </Grid>

            <Grid container spacing={0.5}>
              <Grid item xs={6}>
                <StyledText
                  display="inline"
                  fontSize={13}
                  fontWeight={400}
                  theme="purple"
                >
                  Description
                </StyledText>
              </Grid>
              <Grid item xs={6}>
                <StyledText
                  display="inline"
                  fontSize={14}
                  fontWeight={600}
                  theme="purple"
                >
                  {serviceData.description}
                </StyledText>
              </Grid>

              <Grid item xs={6}>
                <StyledText
                  display="inline"
                  fontSize={13}
                  fontWeight={400}
                  theme="purple"
                >
                  Type
                </StyledText>
              </Grid>
              <Grid item xs={6}>
                <StyledText
                  display="inline"
                  fontSize={14}
                  fontWeight={600}
                  theme="purple"
                >
                  {serviceData.type}
                </StyledText>
              </Grid>

              <Grid item xs={6}>
                <StyledText
                  display="inline"
                  fontSize={13}
                  fontWeight={400}
                  theme="purple"
                >
                  Image URL
                </StyledText>
              </Grid>
              <Grid item xs={6}>
                <StyledText
                  display="block"
                  fontSize={14}
                  fontWeight={600}
                  theme="purple"
                  style={{
                    overflowWrap: "break-word",
                  }}
                  width="100%"
                >
                  {serviceData.imageUrl}
                </StyledText>
              </Grid>
            </Grid>
          </BannerInfo>
        </div>
      </div>
    </StyledBanner>
  );
};

export default ServiceProvidersDashboardBanner;
